import { render, staticRenderFns } from "./DealTransferSlip.vue?vue&type=template&id=626b858c&"
import script from "./DealTransferSlip.vue?vue&type=script&lang=ts&"
export * from "./DealTransferSlip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports